<template>
    <div class="youtube-timer">{{timeFormatted}}</div>
</template>

<script setup lang="ts">
    import { computed } from 'vue';

    const props = defineProps({
        time: {
            type: Number,
            required: true
        },
    });

    const timeFormatted = computed(() => {
        const minutes = Math.floor(props.time / 60);
        const seconds = props.time % 60;

        const paddedMinutes = minutes < 10 ? `0${minutes}` : minutes;
        const paddedSeconds = seconds < 10 ? `0${seconds}` : seconds;

        return `${paddedMinutes}:${paddedSeconds}`;
    });
</script>

<style lang="scss">
    @import url("styles.scss");
</style>